import toast from "react-hot-toast";
import * as api from "../Api/index";
import io from "socket.io-client";
const socket = io();
export const getUnpaidClaims = () => async (dispatch) => {
  try {
    const { data } = await api.unpaidClaims();
    dispatch({ type: "GET ALL UNPAID CLAIMS", payload: data });
  } catch (error) {}
};

export const payClaim = (id, postData) => async (dispatch) => {
  let payingId;
  try {
    payingId = toast.loading("submitting.....");
    await api.payclaim(id, postData);
    dispatch({ type: "PAY CLAIM", payload: id });
    toast.dismiss();
    toast.remove(payingId);
    toast.success("successfully paid");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(payingId);
    toast.error(error.message);
  }
};
